// 获取模块主要获取数据模块
import request from '@/utils/request';
// 获取数据
export const getPowerData = (current, size, name) => request({url: `/look/powerManagement/getSysGroupMenuInfo?current=${current}&size=${size}&name=${name}`, method: 'get'});

// 删除
export const deleteData = (groupCode) => request({url: '/look/powerManagement/deleteSysGroupMenu', method: 'delete', data: groupCode});

// 获取树状图的数据
export const getTreeData = () => request({url: '/look/System/getMenuTree', method: 'get'});

// 新增
export const addPower = (data) => request({url: '/look/powerManagement/insertSysGroupMenu', method: 'post', data});

// 修改
export const revisePower = (data) => request({url: `/look/powerManagement/updateSysGroupMenu`, method: 'put', data});